/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { Header } from '@sitebase/ui-kit';
import toggleText from '../../../common/languages/toggle';
import Collapsible from '../Collapsible';

import './seoBox.scss';

const linesToDisplay = {
    default: 2,
    desktop: 3,
    tablet: 3,
    mobile: 2,
    native: 2,
};

const toggleWording = (locale, text) => (toggleText[locale] && toggleText[locale][text]) || toggleText['en-gb'][text];
const getLinesToDisplay = (platform) => linesToDisplay[platform] || linesToDisplay.default;

const SeoBox = (props) => (
    <div styleName="seo_box">
        <div styleName="seo_box__header_wrapper">
            <Header outfit="level-2">
                {props.data.bottom_h1}
            </Header>
            <h2 styleName="seo_box__title">{props.data.bottom_h2}</h2>
            <Collapsible
                linesToDisplay={getLinesToDisplay(props.platform)}
                showMoreText={toggleWording(props.locale, 'more')}
                showLessText={toggleWording(props.locale, 'less')}
                shortText={props.data.bottom_txt}
                timeStamp={props.data.timeStamp}
            >
                <div
                    styleName="seo_box__expanded"
                    dangerouslySetInnerHTML={{ __html: props.data.bottom_txt_expanded }}
                />
            </Collapsible>
        </div>
    </div>
);

SeoBox.propTypes = {
    data: PropTypes.shape({
        bottom_h1: PropTypes.string.isRequired,
        bottom_h2: PropTypes.string.isRequired,
        bottom_txt: PropTypes.string.isRequired,
        bottom_txt_expanded: PropTypes.string.isRequired,
        timeStamp: PropTypes.number,
    }).isRequired,
    locale: PropTypes.string.isRequired,
    platform: PropTypes.string.isRequired,
};

export default SeoBox;
/* eslint-enable react/destructuring-assignment */
